import { Flex } from "@illimity/web/ui";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import { Box, Button, Typography, useForm } from "@orion/ui";
import LoginFormComponent from "@delorean/login/components/LoginFormComponent";
import {
  LoginFormType,
  loginResetPswSchema,
  LoginResetPswFormType,
  loginSchema,
} from "@delorean/login/schemas/login";
import { zodResolver } from "@hookform/resolvers/zod";
import { useErrorContext } from "@delorean/_shared/context/ErrorContext";
import { useResetPasswordForm } from "../../hook/useResetPasswordForm";
import IdentityFormResetPsw from "../../components/IdentityFormResetPsw";
import { useForgetPasswordIdentityForm } from "../../hook/useForgetPasswordIdentityForm";
import { LoginResetPswType } from "@delorean/forgetPassword/types";

const IdentityResetPswScreen = () => {
  const { t } = useTranslation();
  const { showError, hideError, error } = useErrorContext();
  const { submit } = useForgetPasswordIdentityForm();
  const schema = loginResetPswSchema({ t });
  const form = useForm<LoginResetPswFormType>({
    resolver: zodResolver(schema),
    defaultValues: {
      fiscalCode: "",
      contractCode: "",
      userCode: "",
    },
  });

  const onSubmitForm = (values: LoginResetPswType) => {
    submit(values);
    hideError();
  };

  useEffect(() => {
    /* focus on first input error if form is on error */
    if (Object.keys(form.formState.errors).length > 0) {
      showError(t("login.formValidation.requiredField"));
      const firstInvalidInput = document.querySelector(
        "form *[aria-invalid='true']"
      ) as HTMLInputElement;
      if (firstInvalidInput) {
        firstInvalidInput.focus();
      }
    }
  }, [Object.keys(form.formState.errors).length]);
  useEffect(() => {
    /* focus on error toast message if sersice is on error */
    if (error.visible && !Object.keys(form.formState.errors).length) {
      const errorMessageToast = document.getElementById("errorMessageToast");
      if (errorMessageToast) {
        errorMessageToast.focus();
      }
    }
  }, [error.visible]);

  return (
    <Box
      flex
      column
      my9
      data-landmark="1"
      role="form"
      style={{
        width: "576px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "40px",
        position: "relative",
        zIndex: 1,
      }}
    >
      <Box
        flex
        gap3
        column
        style={{
          width: "576px",
          height: "60px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
        aria-label={t("forgetPassword.title") + " " + t("forgetPassword.subtitle")}
      >
        <Typography text2xl fontBold>
          {t("forgetPassword.title")}
        </Typography>
        <Typography>{t("forgetPassword.subtitle")}</Typography>
      </Box>
      <Box style={{ width: "100%" }}>
        <IdentityFormResetPsw
          form={form}
          onSubmitForm={onSubmitForm}
        />
      </Box>
    </Box>
  );
};

export default IdentityResetPswScreen;
